import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'

// Renders free text (Syfte/Resultat/Nästa steg etc.) as markdown — a plain <span>
// collapses newlines and never draws list markers, and a hand-rolled line parser
// would only handle the flat cases and diverge from the same markdown the Teams
// card (networkingCard.js) already emits (bold, links). remarkBreaks makes a
// single newline a hard line break (like chat apps), not standard markdown's
// "ignore it, join into one paragraph" — matching what someone typing into a
// plain textarea actually expects. No rehype-raw, so literal HTML/script someone
// pastes into the field stays inert text instead of executing.
export const FreeText = ({ text, className }) => {
  if (!text) return null
  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkBreaks]}>{String(text)}</ReactMarkdown>
    </div>
  )
}
